import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import { formatUrl } from '@ifeng-fe/public_method';
import styles from './index.css';
import { rel as relText } from '../../../utils/rel';
import { classNames } from '../../../utils/classnames';
import NewsTitle from '../../components/newsTitle';
import HtmlRegion from '../../../components/htmlRegion';

class ListView extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    listView(list = []) {
        return list.map((item, index) => {
            const url = formatUrl(item.url);

            if (index === 0) {
                return (
                    <li className={styles.first} key={index}>
                        <img src={formatUrl(item.thumbnails, 300, 200)} alt={item.title} />
                        <p className={styles.link}>
                            <a href={url} title={item.title} target="_blank" rel={relText}>
                                {item.title}
                            </a>
                        </p>
                    </li>
                );
            } else {
                return (
                    <li key={index} className={classNames(styles.item, 'clearfix')}>
                        <a className={styles.imageLink} href={url} target="_blank" rel={relText}>
                            <img src={formatUrl(item.thumbnails, 120, 90)} alt={item.title} width={120} height={90} />
                        </a>
                        <div className={styles.titleBox}>
                            <h4 className={styles.title}>
                                <a href={url} title={item.title} target="_blank" rel={relText}>
                                    {item.title}
                                </a>
                            </h4>
                            <a className={styles.desc} href={url} target="_blank" rel={relText}>
                                {item.title}
                                <span className={styles.xiangxi}>【详细】</span>
                            </a>
                        </div>
                    </li>
                );
            }
        });
    }
    render() {
        return <ul className={styles.list}>{this.listView(this.props.content)}</ul>;
    }
}

class HotNews extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { hotNews, hotNewsTitle } = this.props.content;

        return (
            <div className={styles.box}>
                <NewsTitle key="title">
                    <Chip id="30024" type="static" title="热点策划标题" groupName="热点策划" content={hotNewsTitle}>
                        <HtmlRegion />
                    </Chip>
                </NewsTitle>
                <Chip id="60019" type="recommend" title="热点策划" groupName="热点策划" content={hotNews}>
                    <ListView />
                </Chip>
            </div>
        );
    }
}

export default HotNews;
